import React from 'react';

import Button from '../../../components/ui/Button';

const UserCard = ({ user, onEdit, onResetPassword, onToggleStatus }) => {
  const getRoleBadgeColor = (role) => {
    switch (role) {
      case 'Marketing Creator':
        return 'bg-blue-100 text-blue-800';
      case 'Compliance Officer':
        return 'bg-green-100 text-green-800';
      case 'Marketing Director':
        return 'bg-purple-100 text-purple-800';
      case 'Legal Reviewer':
        return 'bg-orange-100 text-orange-800';
      default:
        return 'bg-gray-100 text-gray-800';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'Active':
        return 'text-green-600';
      case 'Inactive':
        return 'text-red-600';
      case 'Pending':
        return 'text-yellow-600';
      default:
        return 'text-gray-600';
    }
  };

  const formatLastActivity = (date) => {
    const now = new Date();
    const activityDate = new Date(date);
    const diffInHours = Math.floor((now - activityDate) / (1000 * 60 * 60));
    
    if (diffInHours < 1) return 'Just now';
    if (diffInHours < 24) return `${diffInHours}h ago`;
    if (diffInHours < 168) return `${Math.floor(diffInHours / 24)}d ago`;
    return activityDate?.toLocaleDateString();
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 hover:shadow-subtle transition-micro">
      <div className="flex items-start justify-between mb-3">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center">
            <span className="text-sm font-medium text-white">
              {user?.name?.split(' ')?.map(n => n?.[0])?.join('')}
            </span>
          </div>
          <div>
            <h3 className="font-medium text-foreground">{user?.name}</h3>
            <p className="text-sm text-muted-foreground">{user?.email}</p>
          </div>
        </div>
        <div className="flex items-center space-x-2">
          <span className={`inline-flex items-center px-2 py-1 rounded-full text-xs font-medium ${getRoleBadgeColor(user?.role)}`}>
            {user?.role}
          </span>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-4 mb-4">
        <div>
          <p className="text-xs text-muted-foreground">Department</p>
          <p className="text-sm font-medium text-foreground">{user?.department}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground">Status</p>
          <p className={`text-sm font-medium ${getStatusColor(user?.status)}`}>
            {user?.status}
          </p>
        </div>
      </div>
      <div className="mb-4">
        <p className="text-xs text-muted-foreground">Last Activity</p>
        <p className="text-sm text-foreground">{formatLastActivity(user?.lastActivity)}</p>
      </div>
      <div className="flex items-center justify-between pt-3 border-t border-border">
        <div className="flex items-center space-x-2">
          <Button
            variant="ghost"
            size="sm"
            iconName="Edit"
            iconSize={14}
            onClick={() => onEdit(user)}
          >
            Edit
          </Button>
          <Button
            variant="ghost"
            size="sm"
            iconName="Key"
            iconSize={14}
            onClick={() => onResetPassword(user)}
          >
            Reset
          </Button>
        </div>
        <Button
          variant={user?.status === 'Active' ? 'outline' : 'default'}
          size="sm"
          onClick={() => onToggleStatus(user)}
        >
          {user?.status === 'Active' ? 'Deactivate' : 'Activate'}
        </Button>
      </div>
    </div>
  );
};

export default UserCard;